var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuejs-datepicker',{attrs:{"language":_vm.ptBR,"bootstrap-styling":true,"format":_vm.customFormatter,"disabledDates":_vm.disabledDates,"placeholder":"DD/MM/AAAA","clear-button":true,"clear-button-icon":'fa fa-close'},on:{"input":_vm.changedDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b20be8c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datepicker/Datepicker.vue
// module id = null
// module chunks = 